<template>
  <div>
    <el-form size="small">
      <el-row :gutter="15">
        <el-col :span="12">
          <DateForm
            ref="dateForm"
          />
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="Profile">
            <ProfileAutoComplete
              ref="profileList"
              v-model="profile"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Rate Card">
            <RateCardAutoComplete
              ref="rateCardList"
              v-model="rateCard"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          class="float-right"
          @click.native="downloadCSV()"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Uprate Report"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import DateForm from '@/components/Application/Reports/DateForm'
import RateCardAutoComplete from '@/components/Application/Reports/RateCardAutoComplete'
import ProfileAutoComplete from '@/components/Application/Reports/ProfileAutoComplete.vue'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    DateForm,
    ProfileAutoComplete,
    RateCardAutoComplete,
    Preview
  },
  data () {
    return {
      pageTitle: 'Uprate',
      breadcrumb: {
        name: 'Uprate',
        route: { name: 'reports-uprate' }
      },
      rateCard: {},
      profile: {},
      form: {
        dateFrom: null,
        dateTo: null,
        rateCardId: null,
        profileId: {}
      },
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    setDate (date) {
      this.form.dateFrom = this.$moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.form.dateTo = this.$moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    downloadCSV () {
      this.$refs.dateForm.$refs.form.validate(async valid => {
        if (valid) {
          this.setDate(this.$refs.dateForm.form.value)
          this.form.profileId = this.$refs.profileList.getProfileId()
          this.form.rateCardId = this.$refs.rateCardList.getRateCardId()

          this.configuration = {
            report: 'UprateReport',
            params: this.form
          }
          this.isShowPreview = true
        }
      })
    }
  }
}
</script>
